import React from "react";

import { GetStaticProps } from "next";
import { PreviewSuspense } from "next-sanity/preview";

import { LazyPreviewPage } from "page/LazyPreviewPage";
import { LoadingScreen } from "page/LoadingScreen";
import { PAGE_DATA_QUERY, PAGE_PATHS_QUERY } from "page/query";
import { PageData } from "page/types";
import { client } from "../../../../sanity/client";

import { GuideCreditCategory } from "page/GuideCreditCategory";
import { groq } from "next-sanity";

interface PageProps {
  data: PageData | null;
  posts: PageData | null;
  preview: boolean;
  slug?: string | null;
  token: string | null;
}

interface Query {
  [key: string]: string;
}

interface PreviewData {
  token?: string;
}

const query = groq`*[_type == "guideAcheteurPosts" && ready_to_be_on_guide == true && categories->title == "investissement immobilier"] | order(_createdAt desc)`;

export const getStaticProps: GetStaticProps<
  PageProps,
  Query,
  PreviewData
> = async (ctx) => {
  let { params = {}, preview = false, previewData = {} } = ctx;

  params.slug = "investissement-immobilier";
  if (preview && previewData.token) {
    return {
      props: {
        data: null,
        posts: null,
        preview,
        slug: "investissement-immobilier",
        token: previewData.token,
      },
    };
  }

  const data = await client.fetch<PageData | null>(PAGE_DATA_QUERY, params);
  const posts = await client.fetch(query);
  return {
    props: {
      data,
      posts,
      preview,
      slug: params?.slug.replace("/fr", "").replace("/ar", "") || null,
      token: null,
    },
  };
};

export default function Page(props: PageProps) {
  const { data, posts, preview, token } = props;
  //
  if (preview) {
    return (
      <PreviewSuspense
        fallback={<LoadingScreen>Loading preview…</LoadingScreen>}
      >
        <LazyPreviewPage slug={"investissement-immobilier"} token={token} />
      </PreviewSuspense>
    );
  }
  return (
    <GuideCreditCategory
      data={data}
      posts={posts}
      postsUrl={"/acheter/guide"}
    />
  );
}
